import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            isLetterFormVisible: false,
            events: [],
            pages: {},
            errors: {}
        };
    },

    mutations: {
        setEvents(state, data) {
            state.events = data;
        },
        setPages(state, data) {
            state.pages = data;
        },
        addEvent(state, data) {
            state.events.splice(0, 0, data);
        },
        setErrors(state, data) {
            state.errors = data;
        },
        clearErrors(state) {
            state.errors = [];
        },
        clearEvents(state) {
            state.events = {};
        }
    },
    actions: {
        getPaginatedList({ state, commit }, params) {
            return new Promise((resolve, reject) => {
                api.get('/event/' + params.entity.type + '/' + params.entity.id + '/?' + qs.stringify(params.data)).then(response => {
                    commit('setEvents', response.data.data);
                    commit('setPages', response.data.meta);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        async createLetter({ state, commit }, params) {
            try {
                commit('clearErrors');
                api.defaults.headers['Content-Type'] = 'multipart/form-data';
                const formData = new FormData();
                Array.from(Object.keys(params)).forEach(item => {
                    if (params[item]) {
                        formData.append(item, params[item]);
                    }
                });
                if (params.files.length) {
                    formData.set('files', JSON.stringify(params.files));
                    params.files.forEach(file => {
                        if (file.raw) {
                            formData.append('file' + file.uid, file.raw, file.raw.name);
                        }
                    });
                }
                const response = await api.post(`/event/${params.entityType}/letter/`, formData);
                commit('addEvent', response.data.data);
            } catch (e) {
                if (e.response && e.response.status === 422) {
                    commit('setErrors', e.response.data.errors);
                }
                throw new Error(e);
            } finally {
                api.defaults.headers['Content-Type'] = 'application/json';
            }
        },
        async getAttachment({ state, commit }, filename) {
            try {
                api.defaults.responseType = 'blob';
                return await api.post('/event/attachment/', { filename });
            } catch (e) {
                throw new Error(e);
            } finally {
                api.defaults.responseType = '';
            }
        },
        async addComment({ state, commit }, { entityType, entityId, data }) {
            try {
                api.defaults.headers['Content-Type'] = 'multipart/form-data';
                const response = await api.post(`/event/${entityType}/add-comment/${entityId}`, data);
                commit('addEvent', response.data.data);
            } catch (e) {
                throw new Error(e);
            } finally {
                api.defaults.headers['Content-Type'] = 'application/json';
            }
        },
        async createSms({ state, commit }, { entityType, entityId, data }) {
            try {
                const response = await api.post(`/message/${entityType}/${entityId}/sms-new`, data);
                return response.data.data;
            } catch (e) {
                throw new Error(e);
            }
        },
        async processMessage({ state, commit }, { entityType, entityId, action }) {
            try {
                const response = await api.get(`/message/${entityType}/${entityId}/${action}`);
                return response.data.data;
            } catch (e) {
                throw new Error(e);
            }
        }
    },
    getters: {}

};

export default store;
